/**
* 佣金管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单佣金管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-select v-model="formInline.hotelId" filterable clearable placeholder="请选择酒店" style="width:300px">
          <el-option v-for="item in hotelSelect" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formInline.userId" filterable clearable placeholder="请选择销售" style="width:150px">
          <el-option v-for="item in saleNames" :key="item.id" :value="item.id" :label="item.userName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-form-item v-if="user.userType==='admin'">
          <el-select v-model="formInline.hotelStatus" clearable placeholder="请选择兑现状态" style="width:150px">
            <el-option v-for="type in hotelStatusList" :label="type.key" :value="type.value"
                       :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-select v-model="formInline.status" clearable placeholder="请选择提取状态" style="width:150px">
          <el-option v-for="type in statusList" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button v-if="user.userType==='admin'" size="small" type="primary" icon="el-icon-check"
                   @click="hotelStatusChange">兑现
        </el-button>
        <el-button v-if="user.userType==='admin'" size="small" type="primary" icon="el-icon-check"
                   @click="statusChange">提取
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" :summary-method="getSummaries" show-summary>
      <el-table-column align="center" type="selection" width="50" :selectable="selectStatus"/>
      <el-table-column align="center" prop="hotelName" label="酒店名称" show-overflow-tooltip/>
      <el-table-column align="center" prop="userName" label="销售名称" show-overflow-tooltip/>
      <el-table-column align="center" sortable prop="orderCode" label="订单编号" show-overflow-tooltip/>
      <el-table-column align="center" sortable prop="orderCreateTime" label="订单时间" show-overflow-tooltip/>
      <el-table-column align="center" sortable prop="orderAmount" label="订单金额" :formatter="moneyFormatter"/>
      <el-table-column v-if="user.userType==='admin'" align="center" label="酒店佣金">
        <el-table-column align="center" prop="hotelProportion" width="80" label="比例" :formatter="proportionFormatter"/>
        <el-table-column align="center" sortable prop="hotelPrice" width="80" label="金额" :formatter="moneyFormatter"/>
        <el-table-column align="center" sortable prop="hotelStatus" width="80" label="状态" show-overflow-tooltip :formatter="hotelStatusFormat"/>
        <el-table-column align="center" sortable prop="cashTime" label="操作时间" show-overflow-tooltip/>
      </el-table-column>
      <el-table-column align="center" label="销售佣金">
        <el-table-column align="center" prop="proportion" width="80" label="比例" :formatter="proportionFormatter"/>
        <el-table-column align="center" sortable prop="price" width="80" label="金额" :formatter="moneyFormatter"/>
        <el-table-column align="center" sortable prop="status" width="80" label="状态" show-overflow-tooltip :formatter="statusFormat"/>
        <el-table-column align="center" sortable prop="extractTime" label="操作时间" show-overflow-tooltip/>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
// 导入请求方法
import {
  orderCommissionList,
  orderCommissionBatchStatusChange
} from '../../api/commissionMg'
import Pagination from '../../components/Pagination'
import {hotelManger, hotelSelect} from "../../api/hotelMg";
// const value1 = ref('')
export default {
  data() {
    return {
      hotelSelect: [], //酒店下拉列表
      statusList: [
        {key: '待确认', value: 0},
        {key: '待提取', value: 1},
        {key: '已提取', value: 2}
      ],
      hotelStatusList: [
        {key: '待确认', value: 0},
        {key: '待兑现', value: 1},
        {key: '已兑现', value: 2}
      ],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加佣金',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      // 编辑与添加
      editForm: {
        id: null,
        userId: null,
        lowerLimit: 0,
        upperLimit: 0,
        proportion: 0,
        token: localStorage.getItem('logintoken')
      },
      // 选择数据
      selectdata: [],
      //销售人员信息
      saleNames: [],
      // rules表单验证
      rules: {
        userid: [
          {required: true, message: '请选择销售人员', trigger: 'blur'}
        ],
        lowerLimit: [{required: true, message: '请输入提成范围', trigger: 'blur'}],
        upperLimit: [{required: true, message: '请输入提成范围', trigger: 'blur'}],
        proportion: [
          {required: true, message: '请输入佣金比例', trigger: 'blur'}
        ]
      },
      // 删除
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      // 请求数据参数
      formInline: {
        pageNum: 1,
        pageSize: 10,
        hotelManageName: null,
        hotelId: null,
        userName: null,
        status: null,
        hotelStatus: null
      },
      //用户数据
      userData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      //角色列表
      roleList: []
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
    if (this.user.userType == "operator") {
      this.formInline.hotelManageName = this.user.userName;
    }
    this.queryHotelList()
    this.getdata(this.formInline)
    this.querySales()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //数据是否允许选中
    selectStatus: function (row) {
      if (row.orderStatus != 3) {
        return false;
      } else {
        return true;
      }
    },
    //比例格式化显示
    proportionFormatter: function (row, column, cellValue) {
      return cellValue + "%";
    },
    //钱格式化显示
    moneyFormatter: function (row, column, cellValue) {
      return cellValue + " 元";
    },
    //佣金统计
    getSummaries: function (param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if ("hotelProportion" === column.property || "proportion" === column.property) {
          sums[index] = "总金额";
          return;
        }
        if ("hotelPrice" != column.property && "price" != column.property) {
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + (curr * 100);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = (sums[index] / 100) + ' 元';
        } else {
          sums[index] = '-';
        }
      });
      console.log(sums)
      return sums;
    },
    //查询酒店列表
    queryHotelList: function () {
      hotelSelect().then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          res.result.forEach(item => {
            this.hotelSelect.push(item);
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: res.message
        })
      })
    },
    //销售提取状态
    statusFormat(row, column) {
      if (row.orderStatus != 3) {
        return "待确认"
      } else if (row.orderStatus == 3 && row.status == 1) {
        return "待提取"
      } else if (row.orderStatus == 3 && row.status == 2) {
        return "已提取"
      }
    },
    //酒店兑现状态
    hotelStatusFormat(row, column) {
      if (row.orderStatus != 3) {
        return '待确认'
      } else if (row.orderStatus == 3 && row.hotelStatus == 1) {
        return '待兑现'
      } else if (row.orderStatus == 3 && row.hotelStatus == 2) {
        return '已兑现'
      }
    },
    handleChange(value) {
      console.log(value);
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      this.loading = false
      //获取用户列表
      orderCommissionList(parameter).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.userData = res.result.rows
          // 分页赋值
          this.pageparm.currentPage = res.result.pagination.current
          this.pageparm.pageSize = res.result.pagination.pageSize
          this.pageparm.total = res.result.pagination.total
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //佣金信息状态变更
    statusChange() {
      const idList = [];
      this.selectdata.forEach((value, index) => {
        idList.push(value.id)
      })
      if (idList.length == 0) {
        this.$alert("请选择需要操作的数据", "提示");
        return;
      }
      this.$confirm('操作不可撤回，确认与销售完成佣金提取?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        orderCommissionBatchStatusChange({idList: idList, status: 2, hotelStatus: null})
          .then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '成功!'
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('操作失败，请稍后再试！')
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消此操作！'
        })
      })
    },
    hotelStatusChange() {
      const idList = [];
      this.selectdata.forEach((value, index) => {
        idList.push(value.id)
      })
      if (idList.length == 0) {
        this.$alert("请选择需要操作的数据", "提示");
        return;
      }
      this.$confirm('操作不可撤回，确认与酒店完成佣金兑现?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        orderCommissionBatchStatusChange({idList: idList, status: null, hotelStatus: 2})
          .then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '成功!'
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('操作失败，请稍后再试！')
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消此操作！'
        })
      })
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.dataAccessshow = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }
    },
    querySales: function () {
      //酒店销售人员
      hotelManger('3').then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          res.result.forEach(item => {
            this.saleNames.push(item);
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: res.msg
        })
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.line {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/hotel/OrderCommission.vue